import React, { useState, useEffect } from 'react';
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import Camperdetails from "../../Components/Camperdetails/Camperdetails";
import Select from 'react-select'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {Link , useParams,useNavigate} from "react-router-dom";  
import CamperService from '../../Api/services/CamperService';

import "react-datepicker/dist/react-datepicker.css";
import YouTubeFacade from '../../Components/YouTubeFacade/YouTubeFacade';

const Availabilityinfo = () => {
  var imageUrl = process.env.REACT_APP_LARAVEL_CAMPER_IMAGE_URL;
  const params = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState("")
  const [camper, setCamper] = useState([]);
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  const [slider1, setSlider1] = useState(null);
  const [slider2, setSlider2] = useState(null);
  const settingsMain = {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.slider-nav'
  };
  const settingsThumbs = {
    slidesToShow: 6,
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    dots: true,
    centerMode: true,
    swipeToSlide: true,
    focusOnSelect: true,
    centerPadding: '10px',
        arrows: true,
        responsive: [
          {
            breakpoint: 1270,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              dots: true,
              arrows: false,
            },
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              dots: true,
              arrows: false,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              arrows: false,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              arrows: false,
            },
          },
        ],
  };
  // const slidesData = [
  //   {
  //     id: 1,
  //     title: 'repellendus id ullam',
  //     label: 'Dolorem officiis temporibus.',
  //     img:"/Images/davidferk_portugal_t6_beach.png"
  //   }, {
  //     id: 2,
  //     title: 'excepturi consequatur est',
  //     label: 'Officia non provident dolor esse et neque.',
  //     img:"/Images/davidferk_portugal_t6_beach.png"
  //   }, {
  //     id: 3,
  //     title: 'eius doloribus blanditiis',
  //     label: 'Ut recusandae vel vitae molestiae id soluta.',
  //     img:"/Images/davidferk_portugal_t6_beach.png"
  //   }, {
  //     id: 4,
  //     title: 'nihil voluptates delectus',
  //     label: 'Qui vel consequatur recusandae illo repellendus.',
  //     img:"/Images/davidferk_portugal_t6_beach.png"
  //   }, {
  //     id: 5,
  //     title: 'nemo dolorem necessitatibus',
  //     label: 'Placeat odit velit itaque voluptatem.',
  //     img:"/Images/davidferk_portugal_t6_beach.png"
  //   }, {
  //     id: 6,
  //     title: 'dolorem quibusdam quasi',
  //     label: 'Adipisci officiis repudiandae.',
  //     img:"/Images/davidferk_portugal_t6_beach.png"
  //   },
  //   {
  //     id: 7,
  //     title: 'dolorem quibusdam quasi',
  //     label: 'Adipisci officiis repudiandae.',
  //     img:"/Images/davidferk_portugal_t6_beach.png"
  //   },
  //   {
  //     id: 8,
  //     title: 'dolorem quibusdam quasi',
  //     label: 'Adipisci officiis repudiandae.',
  //     img:"/Images/davidferk_portugal_t6_beach.png"
  //   },
  // ];

  useEffect(() => {
   
    var id = params.id;
    getCamperByID(id);
    setNav1(slider1);
    setNav2(slider2);
  }, []);
  const getCamperByID = async (id) => {
    try {
      let getCamper = await CamperService.show(id).json();
      setCamper(getCamper.data);
      // console.log(getCamper.data)
    } catch (error) {
      if (error.name === 'HTTPError') {
          const errorJson = await error.response.json();
          setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
        }
    }
  };


  return (
    
    <>
      <Header />
      <main className="min-h-screen">
        <div className="mb-8 flex max-w-screen-xl lg:mx-5 lg:grid lg:grid-cols-12 xl-padded:mx-auto pt-100">
          <div className="fixed z-sticky-collapsible flex w-full flex-col rounded rounded-t-none shadow backdrop-blur-sm transition-all duration-300 dark:bg-off-black-desat dark:shadow-dark lg:hidden pointer-events-none -mt-16 opacity-0 max-h-dynamic-screen-minus-header-mobile top-header-height-mobile bg-white/90 dark:bg-off-black-desat/90">
            <div className="flex w-full cursor-pointer p-5">
              <div className="mr-5 flex flex-1 items-end justify-between">
                <div className="">
                  <p className="text-xs">VW</p>
                  <p className="text-md">T6.1 California Beach</p>
                </div>
                <div className="text-right">
                  <p className="text-xs">per Day</p>
                  <div className="text-md text-primary dark:text-primary-light">
                    from <span className='price-font'>€65</span>
                  </div>
                </div>
              </div>
              <div className="flex items-center">
                <button className="rounded-full bg-primary shadow dark:bg-primary-dark">
                  <div className="inline-block align-top transition-all cssvar-secondary-to-white child:h-8 child:w-8 dark:cssvar-secondary-to-off-white">
                    <svg width="32" height="32" viewBox="0 0 32 32">
                      <g fill="none" fillRule="evenodd">
                        <path
                          d="m16 22.126 7.647-7.647c.47-.47.47-1.234 0-1.705l-.42-.42a1.204 1.204 0 0 0-1.705 0L16 17.876l-5.522-5.522a1.203 1.203 0 0 0-1.704 0l-.422.42c-.47.47-.469 1.235.002 1.705L16 22.126z"
                          fill="var(--svg-color-secondary, #163435)"
                        ></path>
                      </g>
                    </svg>
                  </div>
                </button>
              </div>
            </div>
            <div className="transition-all duration-300 max-h-0 overflow-hidden">
              <hr className="h-[3px] rounded border-none bg-grey dark:bg-grey-dark mx-5 my-0" />
              <div className="p-5 pb-16">
                <div className="flex max-h-full flex-col items-center overflow-auto text-center ">
                  <div className="mb-5 flex items-center justify-center 2xl:mb-2 2xl:flex-col">
                    <div className="inline-block align-top mr-2 child:h-6 child:w-6 dark:cssvar-secondary-to-off-white 2xl:mr-0 2xl:mb-2 2xl:child:h-8 2xl:child:w-8">
                      <svg width="32" height="32" viewBox="0 0 32 32">
                        <g fill="none" fillRule="evenodd">
                          <path
                            d="M16 30.528c-7.968 0-14.496-6.56-14.496-14.528 0-1.792.32-3.488.928-5.088l8.48 17.056c.096.224.256.416.512.416s.416-.192.512-.416l3.904-8.736c.032-.096.096-.192.192-.192s.128.096.192.192l3.904 8.736c.096.224.256.416.512.416s.416-.192.512-.416l8.48-17.056c.608 1.6.928 3.296.928 5.088-.064 7.968-6.592 14.528-14.56 14.528zm0-17.824c-.096 0-.128-.096-.192-.192l-4.544-10.24A13.649 13.649 0 0 1 16 1.44c1.664 0 3.264.288 4.736.832l-4.544 10.24c-.064.128-.096.192-.192.192zm-4.64 10.528c-.096 0-.128-.096-.192-.192L3.808 8.192C5.12 6.176 6.88 4.48 9.024 3.296l5.312 11.808c.064.192.224.256.384.256h2.56c.192 0 .32-.032.416-.256l5.312-11.808a14.997 14.997 0 0 1 5.216 4.896L20.8 23.04c-.032.096-.096.192-.192.192s-.128-.096-.192-.192l-2.784-6.336c-.096-.224-.224-.256-.416-.256h-2.56c-.192 0-.32.032-.416.256l-2.688 6.336c-.032.096-.096.192-.192.192zM16 32c8.864 0 16-7.136 16-16S24.864 0 16 0 0 7.136 0 16s7.136 16 16 16z"
                            fill="var(--svg-color-secondary, #163435)"
                          ></path>
                        </g>
                      </svg>
                    </div>
                    <p className="text-md 2xl:text-md">VW</p>
                  </div>
                  <h2 className="mb-4 whitespace-pre-line text-xl 2xl:text-2xl">
                    T6.1 California Beach
                  </h2>
                  <h3 className="mb-4 text-lg">‚The Space Miracle‘</h3>
                </div>
              </div>
            </div>
          </div>

          <div className="mx-auto w-full lg:col-span-8 xl:px-12 2xl:px-0">
            <div className="pt-12">
            {/* <Slider className="slider-main camper-slider" {...settingsMain}
          asNavFor={nav2}
          ref={slider => (setSlider1(slider))}>
            {slidesData.map((slide) =>
          <div>
            <picture className="text-0 aspect-gallery-mobile md:aspect-gallery-desktop">
              <img slick-slide-image className="inline-block max-w-full object-cover dark:brightness-90 w-full cursor-pointer aspect-gallery-mobile md:aspect-gallery-desktop" src={slide.img} alt="vw_t6_beach_ocean" />
            </picture>
          </div>
           )}
        </Slider>


        <Slider {...settingsThumbs}
            asNavFor={nav1}
            ref={slider => (setSlider2(slider))} className="slider-thumbnail camper-slider">
              {slidesData.map((slide) =>
           <div>
          <picture className="text-0">
              <img className="inline-block object-cover dark:brightness-90 w-full h-full rounded-full lg:rounded-full border border-transparent max-w-full" src={slide.img} alt="vw_t6_beach_ocean" />
            </picture>
          </div> 
           )}
        </Slider>  */}
            </div>
              
              {/* <h1 className="whitespace-pre-line pt-12 pb-6 text-center text-xl md:pt-16 md:pb-9 md:text-2xl big-font">
                Rent VW California Ocean</h1> */}
            <div className="flex flex-col items-center w-full">
              <div className="splide mask-image relative mx-5 aspect-gallery-mobile max-w-3xl self-stretch overflow-hidden rounded-b-lg md:mb-0 md:aspect-gallery-desktop md-padded:mx-auto lg:mx-0 lg:max-w-none splide--slide splide--ltr splide--draggable is-active is-initialized">
                <div className="splide__track splide__track--slide splide__track--ltr splide__track--draggable">
                  <ul
                    className="splide__list"
                    style={{ transform: "translateX(0px)" }}
                  >
                    <li
                      className="splide__slide"
                      style={{ width: "calc(100%)", height: "639.996px" }}
                    >
                      <picture className="text-0 aspect-gallery-mobile md:aspect-gallery-desktop">
                        <img
                          src={imageUrl+camper.image}
                          alt="caampersrent-image"
                        />
                      </picture>
                    </li>
                    <li
                      className="splide__slide"
                      style={{ width: "calc(100%)", height: "639.996px" }}
                    >
                      <picture className="text-0 aspect-gallery-mobile md:aspect-gallery-desktop">
                        <img
                          src="/Images/caampersrent-image-one.png"
                          alt="caampersrent-image"
                        />
                      </picture>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="splide mt-4 h-[60px] max-w-full lg:h-[70px] lg:max-w-[calc(100%-3.5rem*2)] splide--slide splide--ltr splide--draggable splide--nav is-active is-initialized"></div>
            </div>
           
           
            <div className="relative  before:bg-white  mx-5 bg-transparent dark:bg-transparent lg:mx-auto xl:mx-auto">
              <h1 className="whitespace-pre-line pt-12 pb-6 text-center text-xl md:pt-16 md:pb-9 md:text-2xl 2xl:text-3xl">
              Buy a  {camper.title}
              </h1>
              <div className="pb-5">
                <div className="flex flex-col justify-center rounded-lg bg-off-white p-4 dark:bg-black sm:flex-row sm:px-6 sm:py-10">
                {camper.feature && camper.feature.map((feature)=>(
                  <div className="mb-4 flex items-center last:mb-0 sm:mx-2 sm:mb-0 sm:w-1/5 sm:flex-col">
                    <div className="inline-block align-top dark:cssvar-white-to-off-white dark:cssvar-secondary-to-secondary dark:cssvar-primary-to-primary-dark mr-3 child:h-12 child:w-12 sm:mr-0 sm:mb-3 sm:child:h-16 sm:child:w-16">
                      <svg
                        width="80px"
                        height="80px"
                        viewBox="0 0 80 80"
                        version="1.1"
                      >
                        <title>icon_camper_sitzplätze_4</title>
                        <g
                          id="icon_camper_sitzplätze_4"
                          stroke="none"
                          strokeWidth="1"
                          fill="none"
                          fillRule="evenodd"
                        >
                          <g
                            id="usp/0-circle-green"
                            transform="translate(0.343890, 0.000000)"
                          >
                            <path
                              d="M40,0 C62.09139,0 80,17.90861 80,40 C80,62.09139 62.09139,80 40,80 C17.90861,80 0,62.09139 0,40 C0,17.90861 17.90861,0 40,0 Z"
                              id="Path"
                              fill="var(--svg-color-primary, #2f2e2e)"
                            ></path>
                            <path
                              d="M40,3.5 C19.8416066,3.5 3.5,19.8416066 3.5,40 C3.5,60.1583934 19.8416066,76.5 40,76.5 C60.1583934,76.5 76.5,60.1583934 76.5,40 C76.5,19.8416066 60.1583934,3.5 40,3.5 Z"
                              id="Path"
                              fill="var(--svg-color-white, #FFFFFF)"
                            ></path>
                          </g>
                          <g
                            id="Group-2"
                            transform="translate(7.548544, 10.211611)"
                          >
                            <g
                              id="Group"
                              transform="translate(33.403905, 33.471817) rotate(39.000000) translate(-33.403905, -33.471817) translate(9.859230, 9.467738)"
                              fill="var(--svg-color-secondary, #163435)"
                            >
                              <g
                                id="noun-air-1410442"
                                transform="translate(23.544675, 24.004079) scale(-1, 1) rotate(22.000000) translate(-23.544675, -24.004079) translate(5.697537, 5.325558)"
                              >
                                <path
                                  d="M21.1753342,9.72842127 L18.0819652,19.7615905 L11.3362949,19.3596773 C10.2352799,19.2855183 9.18047233,19.8647832 8.70563632,20.8314921 L3.75065773,30.1499232 C3.03351304,31.4986762 3.55028347,33.1889561 4.91336557,33.9529692 C5.58776396,34.3115532 6.37805711,34.3779175 7.03530435,34.1769769 C7.69255159,33.9760363 8.31063802,33.4790779 8.6692078,32.804693 L12.7764328,25.0801262 L20.529117,25.5848917 C20.745521,25.621513 20.9335143,25.5640376 21.1354995,25.5534971 C21.6010506,25.5651591 22.5329417,27.1714611 22.9554698,27.0422813 C24.0824069,26.6977421 24.5093643,24.1628002 24.9123351,22.9613307 L28.2925283,12.0191077 C28.9501316,9.96941896 27.8062239,7.90649094 25.8650152,7.26761297 C23.877082,6.64341436 21.8139057,7.78770968 21.1753342,9.72842127 Z"
                                  id="Path"
                                  transform="translate(15.953507, 20.692790) rotate(17.000000) translate(-15.953507, -20.692790) "
                                ></path>
                                <path
                                  d="M31.003658,9.38123488 C28.4131048,9.38123488 26.3130405,7.28117065 26.3130405,4.69061744 C26.3130405,2.10006423 28.4131048,-8.97380553e-13 31.003658,-8.97380553e-13 C33.5942112,-8.97380553e-13 35.6942754,2.10006423 35.6942754,4.69061744 C35.6942754,7.28117065 33.5942112,9.38123488 31.003658,9.38123488 Z"
                                  id="Path"
                                ></path>
                              </g>
                            </g>
                            <path
                              d="M17.3224866,17.4756749 L17.5387552,20.81392 C17.6411615,22.3946263 16.5292486,23.7958027 14.9666128,24.0552037 C13.8497312,24.2406086 12.7940194,23.4854975 12.6086146,22.3686158 C12.5745852,22.1636221 12.5719219,21.9546459 12.6007161,21.7488515 L13.1384316,17.9057605 C13.2944038,16.7910164 14.1831193,15.922019 15.3010819,15.7910935 C16.2962258,15.6745514 17.1974255,16.3867989 17.3139676,17.3819429 C17.3176174,17.4131079 17.320458,17.4443625 17.3224866,17.4756749 Z M19.6431045,27.3929041 C19.6568083,27.4351228 19.6695747,27.4776399 19.6813942,27.5204244 L23.46794,41.229606 L31.7502583,38.5628275 C33.3770514,38.0388555 35.1451185,38.7595208 35.9420889,40.2714205 L37.7392496,43.6807398 C38.8132189,45.7181226 38.0322179,48.2403718 35.9948351,49.3143411 C35.4118978,49.6216259 34.7644367,49.7863893 34.1055258,49.7951253 L33.090216,49.8085866 L20.4649002,49.997095 C19.3604538,50.0135855 18.451755,49.131623 18.4352645,48.0271766 L18.4347296,44.3620899 C18.1399838,44.1698106 17.9106515,43.8749675 17.8056825,43.5116137 L13.7432523,29.4493777 C13.2573953,27.7675675 14.1934161,26.0035896 15.8584807,25.4631245 C17.4364697,24.9509235 19.1309035,25.8149152 19.6431045,27.3929041 Z"
                              id="Combined-Shape"
                              fill="var(--svg-color-primary, #2f2e2e)"
                            ></path>
                            <path
                              d="M47.9491026,23.1760118 C47.9491026,23.1292096 47.9023004,19.8764569 47.9023004,19.8764569 C47.9257015,19.8764569 50.2658114,19.8530558 50.2658114,19.8296547 C50.2658114,19.8296547 50.3594157,17.6533525 50.2658114,17.4661437 C49.8679927,17.4427426 47.9959048,17.4193415 47.9959048,17.4193415 L48.0193059,7.0526547 C47.4108773,6.74844042 45.5855916,6.60803383 44.8835586,6.60803383 C43.6667015,8.12910525 38.1674432,16.3194898 37.629218,17.6065503 C37.5824158,18.1213745 37.8164268,19.4786382 37.9334323,19.9232591 C38.8460751,19.9700613 44.5325421,19.9232591 45.1175696,19.899858 L45.1175696,23.0590063 C45.9834103,23.3632206 47.106663,23.3632206 47.9491026,23.1760118 Z M45.3047784,10.5160173 L45.1409707,17.4427426 L40.6479597,17.4661437 C41.0457784,16.5769019 44.7899542,11.0776437 45.211174,10.4926162 L45.3047784,10.5160173 Z"
                              id="Shape"
                              fill="var(--svg-color-primary, #2f2e2e)"
                            ></path>
                            <path
                              d="M44.8835586,6.34211224 C45.9436015,6.34211224 47.578407,6.53489591 48.1382296,6.81480721 L48.2855987,6.88849175 L48.2621048,17.156611 L49.5101944,17.1778205 C49.8877581,17.1856035 50.1551033,17.1932502 50.2814268,17.200681 L50.4349034,17.209709 L50.5036589,17.34722 C50.5682962,17.4764947 50.5808854,17.8077862 50.5714029,18.4603994 L50.5524014,19.2668879 L50.5317329,19.8296547 L50.3088622,20.0930901 C50.2761561,20.1266684 50.2741321,20.117206 50.2700842,20.0982812 L49.9775317,20.11082 L48.9674641,20.1296143 L48.1716915,20.1391874 L48.2145541,23.1345386 L48.2150242,23.3893266 L48.0067891,23.435601 C47.0522743,23.6477154 45.8933255,23.613427 45.0294203,23.3098927 L44.851648,23.2474322 L44.8508628,20.1721617 L41.6936684,20.2035017 C41.2848879,20.2057797 40.877211,20.2074936 40.4938437,20.208416 L38.6327038,20.2043379 C38.2980402,20.2009834 38.0568201,20.1958577 37.9198131,20.1888317 L37.7257252,20.1788785 L37.6762663,19.9909343 C37.5123622,19.368099 37.3208824,18.0610413 37.3838841,17.5039561 C37.6323944,16.9096923 38.8958927,14.8903102 40.6105155,12.3037729 L41.4351534,11.0681565 C42.8790058,8.91932609 44.1639495,7.08186303 44.6759088,6.44191393 L44.8835586,6.34211224 Z M45.3473743,6.88551052 L45.0114794,6.87501908 L44.742321,7.23270028 C44.1179974,8.07876944 43.0490366,9.61988144 41.8768464,11.3644067 L41.4409265,12.0155121 C40.4688085,13.4727654 39.6142479,14.7878097 38.984241,15.7887304 L38.5120033,16.5488954 C38.1870312,17.0806556 37.9710444,17.4573022 37.8940475,17.6306257 C37.8635237,17.9663866 37.9860224,18.8932593 38.1141936,19.521554 L38.1443206,19.6647833 L39.4240924,19.676881 L44.320667,19.6488289 C44.7113301,19.6437409 44.9947357,19.6386371 45.1069412,19.6341489 L45.3834912,19.6230869 L45.3827059,22.8622244 L45.4434075,22.8815978 C46.0981752,23.0586328 46.9099214,23.0847257 47.6273095,22.9672088 L47.6792047,22.9558288 L47.632562,19.6131044 L49.8555877,19.5819191 L50.0086777,19.577561 L50.036541,18.6365474 L50.0407905,18.14102 L50.0352699,17.7214284 L48.7758947,17.6965253 L47.7293899,17.6818497 L47.752599,7.23029031 L47.6604702,7.20098482 C47.1361352,7.04534253 46.1518308,6.92259754 45.3473743,6.88551052 Z M45.1007321,10.1909001 L45.5756551,10.3096308 L45.4007099,17.707315 L40.2367157,17.7342108 L40.4052217,17.3575504 C40.7106931,16.6747319 43.6300344,12.2780214 44.793319,10.621835 L45.1007321,10.1909001 Z M44.880646,17.1778847 L45.0210526,11.2244324 L44.0760785,12.6117823 C43.0620646,14.1169497 41.8345419,15.9842657 41.2343788,16.9696124 L41.0971138,17.1980948 L44.880646,17.1778847 Z"
                              id="Shape"
                              fill="var(--svg-color-primary, #2f2e2e)"
                              fillRule="nonzero"
                            ></path>
                          </g>
                        </g>
                      </svg>
                    </div>
                    <p className="whitespace-pre-line text-md sm:text-center">
                      {feature.title}
                    </p>
                  </div>
                  ))}
                </div>
              </div>
                {camper.camper_details && camper.camper_details.map((camper_details)=>(
              <div className="div">
                  <div className="pt-8 2xl:pt-12 pb-8 2xl:pb-12 text-left mx-auto max-w-3xl">
                  {camper.price_additional && camper.price_additional.map((sale)=>{
                    return <>
                    <h2 className="my-5 first:mt-0 break-words text-xl md:text-2xl">

                    ⭐️ Save <span className='price-font'>{sale.regularPrice-sale.salePrice}€ </span>⭐️
                    </h2>
                    <h4 className="my-5 first:mt-0 break-words text-lg">
                      <span className='price-font'>{sale.salePrice.toLocaleString()}€</span> instead of <span className='price-font'>{sale.regularPrice.toLocaleString()}€*</span>
                    </h4>
                    </>
                  })}
                    
                    <div className="min-h-[30px] break-words text-sm 2xl:text-2md 2xl:font-normal">
                      <p  dangerouslySetInnerHTML={{ __html: camper_details.details}}>
                      </p>
                    </div>
                  </div>

                  <div className="pt-4 2xl:pt-8 pb-8 2xl:pb-12">
                    {camper.basic && camper.basic.map((basic)=>(
                    <div className="overflow-hidden rounded bg-white shadow dark:bg-off-black-desat dark:shadow-dark 2xs:rounded-lg sm:rounded-lg md:rounded-lg p-0">
                      <details className="group" open>
                        <summary className="flex cursor-pointer select-none items-center justify-between py-6 px-5 md:p-8">
                          <div className="inline-flex items-center justify-center rounded-full border bg-white p-1 dark:border-primary-dark dark:bg-off-white mr-4 border-warning-alternative">
                            <div className="inline-block align-top child:h-7 child:w-7">
                              <svg
                                width="32px"
                                height="32px"
                                viewBox="0 0 32 32"
                                version="1.1"
                              >
                                <title>
                                  icon_technical_multifunktion-lenkrad_steering-wheel
                                </title>
                                <g
                                  id="icon_technical_multifunktion-lenkrad_steering-wheel"
                                  stroke="none"
                                  strokeWidth="1"
                                  fill="none"
                                  fillRule="evenodd"
                                >
                                  <path
                                    d="M15.9995123,27 C22.0751036,27 27,22.0751036 27,15.9990246 C27,9.92440868 22.0751036,5 15.9995123,5 C9.92392099,5 5,9.92440868 5,15.9990246 C4.99975616,22.0751036 9.92392099,27 15.9995123,27 Z M13.215801,16.2518898 C13.215801,14.7204421 14.456852,13.4781761 15.9900008,13.4781761 C17.5224205,13.4781761 18.7642005,14.7201991 18.7642005,16.2518898 C18.7642005,17.7845525 17.5226635,19.0256035 15.9900008,19.0256035 C14.456852,19.0256035 13.215801,17.7845525 13.215801,16.2518898 Z M17.0495001,24.8473543 C17.8310168,21.2682273 20.8841746,18.5418191 24.6227749,18.253109 C23.7103146,21.754694 20.7217752,24.4159961 17.0495001,24.8473543 Z M15.9995123,7.08900268 C20.5218239,7.08900268 24.2543282,10.4584248 24.8310168,14.8234577 C21.9300171,14.2460376 19.6593514,10.9041697 15.9995123,10.9041697 C12.2874909,10.9041697 10.5584004,14.3413802 7.16508169,14.8451597 C7.7315289,10.4698854 11.4696416,7.08900268 15.9995123,7.08900268 Z M14.8239454,24.8312607 C11.2133626,24.355523 8.28505243,21.7207998 7.3796635,18.2645696 C11.0553524,18.6022921 14.0468178,21.3001707 14.8239454,24.8312607 Z"
                                    id="Shape"
                                    fill="var(--svg-color-secondary, #163435)"
                                  ></path>
                                </g>
                              </svg>
                            </div>
                          </div>
                          <h3 className="overflow-hidden text-ellipsis text-lg">
                          Basic data {camper.title}
                          </h3>
                          <div className="inline-block align-top pl-4 child:h-8 child:w-8 child:transition-all group-open:child:rotate-180 dark:cssvar-secondary-to-off-white md:pl-6">
                            <svg width="32" height="32" viewBox="0 0 32 32">
                              <g fill="none" fillRule="evenodd">
                                <path
                                  d="m16 22.126 7.647-7.647c.47-.47.47-1.234 0-1.705l-.42-.42a1.204 1.204 0 0 0-1.705 0L16 17.876l-5.522-5.522a1.203 1.203 0 0 0-1.704 0l-.422.42c-.47.47-.469 1.235.002 1.705L16 22.126z"
                                  fill="var(--svg-color-secondary, #163435)"
                                ></path>
                              </g>
                            </svg>
                          </div>
                        </summary>
                        <div className="mb-5 px-5 md:mb-9 md:px-9">
                          <hr className="my-5 h-[3px] rounded border-none bg-grey dark:bg-grey-dark mt-0" />
                          <div className="my-8 sm:mx-8 lg:mx-0 xl:mx-8">
                               
                              <div>
                                <div className="flex flex-col justify-between sm:flex-row">
                                  <p className="mb-1 whitespace-pre-line text-md sm:mb-0">Model</p>
                                  <p className="whitespace-pre-line sm:text-right">{basic.model}</p>
                                </div>
                                <hr className="h-[3px] rounded border-none bg-grey dark:bg-grey-dark my-3" />
                              </div>
                              <div>
                                <div className="flex flex-col justify-between sm:flex-row">
                                  <p className="mb-1 whitespace-pre-line text-md sm:mb-0">Fuel type</p>
                                  <p className="whitespace-pre-line sm:text-right">{basic.fuel.title}(soot particle filter)</p>
                                </div>
                                <hr className="h-[3px] rounded border-none bg-grey dark:bg-grey-dark my-3" />
                              </div>
                              <div>
                              <div>
                                <div className="flex flex-col justify-between sm:flex-row">
                                  <p className="mb-1 whitespace-pre-line text-md sm:mb-0">Engine</p>
                                  <p className="whitespace-pre-line sm:text-right">{basic.engine}</p>
                                </div>
                                <hr className="h-[3px] rounded border-none bg-grey dark:bg-grey-dark my-3" />
                              </div>  
                             
                                <div className="flex flex-col justify-between sm:flex-row">
                                  <p className="mb-1 whitespace-pre-line text-md sm:mb-0">Transmission</p>
                                  <p className="whitespace-pre-line sm:text-right">{basic.transmission}</p>
                                </div>
                                <hr className="h-[3px] rounded border-none bg-grey dark:bg-grey-dark my-3" />
                              </div> 
                              <div>
                                <div className="flex flex-col justify-between sm:flex-row">
                                  <p className="mb-1 whitespace-pre-line text-md sm:mb-0">Color exterior</p>
                                  <p className="whitespace-pre-line sm:text-right">{basic.ce}</p>
                                </div>
                                <hr className="h-[3px] rounded border-none bg-grey dark:bg-grey-dark my-3" />
                              </div> 
                              <div>
                                <div className="flex flex-col justify-between sm:flex-row">
                                  <p className="mb-1 whitespace-pre-line text-md sm:mb-0">Color interior</p>
                                  <p className="whitespace-pre-line sm:text-right">{basic.interior}</p>
                                </div>
                                <hr className="h-[3px] rounded border-none bg-grey dark:bg-grey-dark my-3" />
                              </div> 
                              <div>
                                <div className="flex flex-col justify-between sm:flex-row">
                                  <p className="mb-1 whitespace-pre-line text-md sm:mb-0">Seats</p>
                                  <p className="whitespace-pre-line sm:text-right">{basic.seats}</p>
                                </div>
                                <hr className="h-[3px] rounded border-none bg-grey dark:bg-grey-dark my-3" />
                              </div> 
                              <div>
                                <div className="flex flex-col justify-between sm:flex-row">
                                  <p className="mb-1 whitespace-pre-line text-md sm:mb-0">Doors</p>
                                  <p className="whitespace-pre-line sm:text-right">{basic.door}</p>
                                </div>
                                <hr className="h-[3px] rounded border-none bg-grey dark:bg-grey-dark my-3" />
                              </div>   
                              <div>
                                <div className="flex flex-col justify-between sm:flex-row">
                                  <p className="mb-1 whitespace-pre-line text-md sm:mb-0">Wheelbase</p>
                                  <p className="whitespace-pre-line sm:text-right">{basic.wheelbase}</p>
                                </div>
                                <hr className="h-[3px] rounded border-none bg-grey dark:bg-grey-dark my-3" />
                              </div> 
                                                
                          </div>
                        </div>
                      </details>
                    </div>     
                    ))}                     
                  </div>
                  <div className="pt-8 2xl:pt-12 pb-8 2xl:pb-12">
                    <div className="relative mx-auto max-w-3xl">
                      {/* <div className="mask-image relative h-0 w-full overflow-hidden rounded bg-off-white pt-[56.25%] shadow dark:bg-black dark:shadow-dark 2xs:rounded-lg">
                        <iframe
                          className="absolute top-0 left-0 aspect-video h-full w-full"
                          src={camper_details.video_url}
                          frameborder="0"
                        ></iframe>
                      </div> */}
                        <YouTubeFacade
                          videoUrl={camper_details.video_url}
                          title=""
                        />
                    </div>
                  </div>
              </div>

                   ))}
            </div>
           
            <div className="mx-5 mb-8 lg:mx-auto xl:mx-auto">
            <div className="pt-4 2xl:pt-8 pb-8 2xl:pb-12">
                  {camper.basic && camper.basic.map((basic)=>(
                    <div className="overflow-hidden rounded bg-white shadow dark:bg-off-black-desat dark:shadow-dark 2xs:rounded-lg sm:rounded-lg md:rounded-lg p-0">
                      <details className="group" open>
                        <summary className="flex cursor-pointer select-none items-center justify-between py-6 px-5 md:p-8">
                          <div className="inline-flex items-center justify-center rounded-full border bg-white p-1 dark:border-primary-dark dark:bg-off-white mr-4 border-warning-alternative">
                            <div className="inline-block align-top child:h-7 child:w-7">
                              <svg
                                width="32px"
                                height="32px"
                                viewBox="0 0 32 32"
                                version="1.1"
                              >
                                <title>
                                  icon_technical_multifunktion-lenkrad_steering-wheel
                                </title>
                                <g
                                  id="icon_technical_multifunktion-lenkrad_steering-wheel"
                                  stroke="none"
                                  strokeWidth="1"
                                  fill="none"
                                  fillRule="evenodd"
                                >
                                  <path
                                    d="M15.9995123,27 C22.0751036,27 27,22.0751036 27,15.9990246 C27,9.92440868 22.0751036,5 15.9995123,5 C9.92392099,5 5,9.92440868 5,15.9990246 C4.99975616,22.0751036 9.92392099,27 15.9995123,27 Z M13.215801,16.2518898 C13.215801,14.7204421 14.456852,13.4781761 15.9900008,13.4781761 C17.5224205,13.4781761 18.7642005,14.7201991 18.7642005,16.2518898 C18.7642005,17.7845525 17.5226635,19.0256035 15.9900008,19.0256035 C14.456852,19.0256035 13.215801,17.7845525 13.215801,16.2518898 Z M17.0495001,24.8473543 C17.8310168,21.2682273 20.8841746,18.5418191 24.6227749,18.253109 C23.7103146,21.754694 20.7217752,24.4159961 17.0495001,24.8473543 Z M15.9995123,7.08900268 C20.5218239,7.08900268 24.2543282,10.4584248 24.8310168,14.8234577 C21.9300171,14.2460376 19.6593514,10.9041697 15.9995123,10.9041697 C12.2874909,10.9041697 10.5584004,14.3413802 7.16508169,14.8451597 C7.7315289,10.4698854 11.4696416,7.08900268 15.9995123,7.08900268 Z M14.8239454,24.8312607 C11.2133626,24.355523 8.28505243,21.7207998 7.3796635,18.2645696 C11.0553524,18.6022921 14.0468178,21.3001707 14.8239454,24.8312607 Z"
                                    id="Shape"
                                    fill="var(--svg-color-secondary, #163435)"
                                  ></path>
                                </g>
                              </svg>
                            </div>
                          </div>
                          <h3 className="overflow-hidden text-ellipsis text-lg">
                          Technical details {camper.title}
                          </h3>
                          <div className="inline-block align-top pl-4 child:h-8 child:w-8 child:transition-all group-open:child:rotate-180 dark:cssvar-secondary-to-off-white md:pl-6">
                            <svg width="32" height="32" viewBox="0 0 32 32">
                              <g fill="none" fillRule="evenodd">
                                <path
                                  d="m16 22.126 7.647-7.647c.47-.47.47-1.234 0-1.705l-.42-.42a1.204 1.204 0 0 0-1.705 0L16 17.876l-5.522-5.522a1.203 1.203 0 0 0-1.704 0l-.422.42c-.47.47-.469 1.235.002 1.705L16 22.126z"
                                  fill="var(--svg-color-secondary, #163435)"
                                ></path>
                              </g>
                            </svg>
                          </div>
                        </summary>
                        <div className="mb-5 px-5 md:mb-9 md:px-9">
                          <hr className="my-5 h-[3px] rounded border-none bg-grey dark:bg-grey-dark mt-0" />
                          <div className="my-8 sm:mx-8 lg:mx-0 xl:mx-8">
                              <div>
                                <div className="flex flex-col justify-between sm:flex-row">
                                  <p className="mb-1 whitespace-pre-line text-md sm:mb-0">Actuator</p>
                                  <p className="whitespace-pre-line sm:text-right">{basic.actuator}</p>
                                </div>
                                <hr className="h-[3px] rounded border-none bg-grey dark:bg-grey-dark my-3" />
                              </div>   
                              <div>
                                <div className="flex flex-col justify-between sm:flex-row">
                                  <p className="mb-1 whitespace-pre-line text-md sm:mb-0">Gearbox</p>
                                  <p className="whitespace-pre-line sm:text-right">{basic.model}</p>
                                </div>
                                <hr className="h-[3px] rounded border-none bg-grey dark:bg-grey-dark my-3" />
                              </div>
                              <div>
                                <div className="flex flex-col justify-between sm:flex-row">
                                  <p className="mb-1 whitespace-pre-line text-md sm:mb-0">Number of gears</p>
                                  <p className="whitespace-pre-line sm:text-right">{basic.numberOfGears}</p>
                                </div>
                                <hr className="h-[3px] rounded border-none bg-grey dark:bg-grey-dark my-3" />
                              </div>  
                              <div>
                                <div className="flex flex-col justify-between sm:flex-row">
                                  <p className="mb-1 whitespace-pre-line text-md sm:mb-0">Cubic capacity</p>
                                  <p className="whitespace-pre-line sm:text-right">{basic.capacity}</p>
                                </div>
                                <hr className="h-[3px] rounded border-none bg-grey dark:bg-grey-dark my-3" />
                              </div> 
                              <div>
                                <div className="flex flex-col justify-between sm:flex-row">
                                  <p className="mb-1 whitespace-pre-line text-md sm:mb-0">Number cylinders</p>
                                  <p className="whitespace-pre-line sm:text-right">{basic.cc}</p>
                                </div>
                                <hr className="h-[3px] rounded border-none bg-grey dark:bg-grey-dark my-3" />
                              </div> 
                              <div>
                                <div className="flex flex-col justify-between sm:flex-row">
                                  <p className="mb-1 whitespace-pre-line text-md sm:mb-0">Weight (when empty)</p>
                                  <p className="whitespace-pre-line sm:text-right">{basic.emptyWeight}</p>
                                </div>
                                <hr className="h-[3px] rounded border-none bg-grey dark:bg-grey-dark my-3" />
                              </div> 
                              <div>
                                <div className="flex flex-col justify-between sm:flex-row">
                                  <p className="mb-1 whitespace-pre-line text-md sm:mb-0">Emission class</p>
                                  <p className="whitespace-pre-line sm:text-right">{basic.ec}</p>
                                </div>
                                <hr className="h-[3px] rounded border-none bg-grey dark:bg-grey-dark my-3" />
                              </div> 
                              <div>
                                <div className="flex flex-col justify-between sm:flex-row">
                                  <p className="mb-1 whitespace-pre-line text-md sm:mb-0">Emissions sticker</p>
                                  <p className="whitespace-pre-line sm:text-right">{basic.cpkm}</p>
                                </div>
                                <hr className="h-[3px] rounded border-none bg-grey dark:bg-grey-dark my-3" />
                              </div>   
                              <div>
                                <div className="flex flex-col justify-between sm:flex-row">
                                  <p className="mb-1 whitespace-pre-line text-md sm:mb-0">CO2 emissions</p>
                                  <p className="whitespace-pre-line sm:text-right">{basic.fueltank}</p>
                                </div>
                                <hr className="h-[3px] rounded border-none bg-grey dark:bg-grey-dark my-3" />
                              </div> 
                              <div>
                                <div className="flex flex-col justify-between sm:flex-row">
                                  <p className="mb-1 whitespace-pre-line text-md sm:mb-0">Fuel consumption</p>
                                  <p className="whitespace-pre-line sm:text-right">{basic.dimentions}</p>
                                </div>
                                <hr className="h-[3px] rounded border-none bg-grey dark:bg-grey-dark my-3" />
                              </div>          
                          </div>
                        </div>
                      </details>
                    </div>     
                  ))}                     
              </div>
              <div className="pt-8 2xl:pt-12 pb-4 2xl:pb-8">
                         <Camperdetails/>                           
              </div>
             
              <div className="pt-8 2xl:pt-12 pb-8 2xl:pb-12">
                  <div className="overflow-hidden rounded bg-white p-6 shadow dark:bg-off-black-desat dark:shadow-dark 2xs:rounded-lg mx-auto flex max-w-3xl flex-col items-center md:p-8 2xl:p-16">
                    <div className="inline-flex items-center justify-center rounded-full border bg-white p-1 dark:bg-off-white mb-6 border-info dark:border-info">
                          <div className="inline-block align-top child:h-8 child:w-8 2xl:child:h-10 2xl:child:w-10">
                          <svg width="32px" height="32px" viewBox="0 0 32 32" version="1.1">
                          <title>icon/actions_info</title>
                          <g id="icon/actions_info" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                          <path d="M15.0627781,13.2833484 C14.2292216,13.2833484 13.4095577,13.2833484 12.5843367,13.2833484 C12.4040026,13.2849033 12.2246588,13.3085077 12.0508606,13.3535621 C11.8387141,13.3950229 11.676741,13.5559636 11.6451964,13.7566407 C11.5865132,13.9746677 11.7037133,14.2006319 11.9230486,14.2923451 C12.190053,14.4092135 12.476874,14.4813856 12.7704977,14.5055866 C13.5429267,14.5393932 13.8541211,14.8566551 13.7374232,15.6004 C13.5206985,16.9916712 13.2289538,18.3725403 12.9788868,19.7612109 C12.809397,20.6973934 12.6848928,21.2550492 12.5843367,22.2403035 C12.4530963,23.5262052 13.2109841,24.7401952 14.1368811,25.0131061 C15.0627781,25.286017 15.724825,25.286017 16.3214484,25.2794864 C17.5999796,25.2780159 18.8212793,24.7831633 19.6973522,23.9116198 C19.8564682,23.7743898 19.9759403,23.6017433 20.0446674,23.409722 C20.0782267,23.2419815 20.0359721,23.0687264 19.9279695,22.9312287 C19.7974575,22.8547704 19.6367149,22.8384803 19.4917416,22.8870201 C19.2639028,22.9572338 19.0610707,23.1028622 18.838789,23.1938799 C18.5790019,23.3073326 18.3070186,23.3945099 18.0274607,23.4539306 C17.8020089,23.5057029 17.5636393,23.4622801 17.3753928,23.335146 C17.1871463,23.2080119 17.0679843,23.0099721 17.0494211,22.7934019 C17.0026623,22.551429 16.9942363,22.3043299 17.0244144,22.0600589 C17.1188841,21.4567414 17.2522531,20.8586248 17.3689511,20.2605082 C17.6857025,18.6291236 18.0070849,16.9968722 18.3330981,15.3637539 C18.4220108,14.9164667 18.5720509,14.4769811 18.4720242,14.0062893 C18.4564927,13.79721 18.3517318,13.6027725 18.1813424,13.4667803 C18.010953,13.3307881 17.7892668,13.2646798 17.5662261,13.2833484 C16.7326696,13.2833484 15.8963346,13.2833484 15.0627781,13.2833484 Z" id="Path" fill="var(--svg-color-secondary, #163435)"></path>
                          <path d="M16.5742939,6.28268183 C15.5498224,6.23775316 14.6000794,6.81738803 14.1716262,7.74904688 C13.743173,8.68070573 13.9212618,9.77901022 14.6221567,10.5275466 C15.3230516,11.276083 16.4072909,11.52591 17.3650741,11.159561 C18.3228574,10.793212 18.9636082,9.88358197 18.9860507,8.85837141 C19.0250803,7.48444098 17.9479291,6.33655519 16.5742939,6.28823887 L16.5742939,6.28268183 Z" id="Path" fill="var(--svg-color-secondary, #163435)"></path>
                          </g>
                          </svg>                  
                          </div>
                    </div>
                    <p className="whitespace-pre-line text-center text-lg md:text-xl">Questions? We have answers!</p>
                    <Link to={"/contactus"} className="group/button block disabled:opacity-50 border border-transparent rounded text-md text-white dark:text-off-white p-3 hover:bg-secondary group-hover/parent:bg-secondary dark:hover:text-off-black dark:group-hover/parent:text-off-black dark:hover:bg-off-white dark:group-hover/parent:bg-off-white transition-all shadow dark:shadow-dark hover:shadow-elevated dark:hover:shadow-dark-elevated pl-3 py-2 w-full mt-6 bg-info dark:bg-info">
                      <div className="flex h-full items-center justify-between">
                          <div className="inline-block align-top mr-2 rounded-full bg-white p-1 child:h-7 child:w-7 dark:bg-off-white">
                          <svg width="32px" height="32px" viewBox="0 0 32 32" version="1.1">
                          <title>icon/actions_question</title>
                          <g id="icon/actions_question" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                          <path d="M16.5609275,17.3580413 L16.3692127,19.2467266 C15.73983,19.3562778 14.562691,19.3562778 13.8779956,19.3015022 C13.6320422,19.027624 13.6862809,15.1407023 13.6862809,15.1407023 C16.2596615,15.1407023 18.2305102,14.2369044 18.2305102,12.1838923 C18.2305102,11.1442293 17.4915762,9.66582429 15.3837884,9.66582429 C13.4951032,9.66582429 12.1536372,10.6512486 12.1536372,10.6512486 C12.1536372,10.6512486 10.9222596,8.70778776 11.003886,8.05048019 C11.6338057,7.33947102 13.3033885,6.6 15.8767691,6.6 C19.0242198,6.6 21.6523761,8.43390961 21.6523761,11.8831633 C21.6523761,15.1680901 19.2707101,17.0019997 16.5609275,17.3580413 M16.5732788,25.0115932 C15.8048089,25.7891924 14.5471175,25.7972476 13.7695183,25.0287777 C12.9913822,24.2608449 12.9833269,23.0031534 13.7517968,22.2250173 C14.5197297,21.4468811 15.7779581,21.4393629 16.5555573,22.2072957 C17.3336935,22.9757656 17.3412117,24.2334571 16.5732788,25.0115932" id="Fill-1" fill="var(--svg-color-secondary, #163435)"></path>
                          </g>
                          </svg>
                            </div>  
                            <span className="flex">
                            To the helpcenter
                            </span>
                            <div className="inline-block align-top min-w-max child:h-6 child:w-6 dark:cssvar-secondary-to-off-white ml-2 cssvar-secondary-to-white dark:group-hover/button:cssvar-secondary-to-off-black dark:group-hover/parent:cssvar-secondary-to-off-black">
                            <svg width="32" height="32" viewBox="0 0 32 32">
                              <g fill="none" fillRule="evenodd">
                                  <path d="m22.126 16-7.647-7.647a1.207 1.207 0 0 0-1.705 0l-.42.42a1.204 1.204 0 0 0 0 1.705L17.876 16l-5.522 5.522a1.203 1.203 0 0 0 0 1.704l.42.422c.47.47 1.235.469 1.705-.002L22.126 16z" fill="var(--svg-color-secondary, #163435)"></path>
                              </g>
                            </svg>
                              </div>                
                      </div>
                    </Link>
                    </div>                              
              </div>  
            </div>
          </div>

          <div className="lg:col-span-4">
            <div className="overflow-hidden rounded bg-white shadow dark:bg-off-black-desat dark:shadow-dark 2xs:rounded-lg sticky ml-8 mt-8 hidden p-5 pt-7 transition-all duration-300 lg:block top-6">
              <div className="flex max-h-[calc(100vh-80px)] flex-col custom-max-h">
                <div className="flex max-h-full flex-col items-center overflow-auto text-center">
                  <h2 className="mb-4 whitespace-pre-line text-xl 2xl:text-2xl">
                   {camper.title}
                  </h2>
                  {camper.camper_details && camper.camper_details.map((camper_details)=>(
                  <h3 className="mb-4 text-lg">{camper_details.sub_title} </h3>))} 
                  <form className="w-full" action="">
                    <input type="hidden" name="lang" value="en" />
                    <input type="hidden" name="camper" value="1040" />
                   
                    <div className="mt-4 w-full rounded bg-off-white p-5 text-left dark:bg-black">
                    {camper.inclusive && camper.inclusive.map((inclusive)=>(
                      <div className="mb-4 flex items-center last:mb-0">
                        <div className="inline-flex items-center justify-center rounded-full border border-primary bg-white dark:border-primary-dark dark:bg-off-white mr-3 p-0">
                          <div className="inline-block align-top child:h-6 child:w-6">
                            <svg width="32" height="32" viewBox="0 0 32 32">
                              <g fill="none" fillRule="evenodd">
                                <path
                                  d="m21.906 9.488-8.547 9.56-3.45-3.096a1.757 1.757 0 0 0-2.563.209c-.64.792-.547 1.98.21 2.659l4.764 4.274c.735.66 1.833.602 2.496-.13l9.73-10.869a1.954 1.954 0 0 0-.069-2.665 1.758 1.758 0 0 0-2.571.058z"
                                  fill="var(--svg-color-secondary, #163435)"
                                ></path>
                              </g>
                            </svg>
                          </div>
                        </div>
                        <p className="text-md">{inclusive.i_title}</p>
                      </div>
                       ))}
                    </div>

                    <div className="my-4 flex min-h-[70px] w-full flex-col justify-center 2xl:my-8">
                     
                    <div className="mb-1 text-xl text-primary dark:text-primary-light">
                      from {camper.price_additional && camper.price_additional.map((sale)=>(<span className='price-font'>€{sale.salePrice.toLocaleString()}</span>))}
                      </div>
                      <p className="text-xs mb-6">Sales price incl. VAT</p>
                      <Link to={`/rentconfiguration/${camper.id}`}  className="group/button block disabled:opacity-50 border border-transparent rounded text-md text-white dark:text-off-white bg-primary dark:bg-primary-dark p-3 pl-5 hover:bg-secondary group-hover/parent:bg-secondary dark:hover:text-off-black dark:group-hover/parent:text-off-black dark:hover:bg-off-white dark:group-hover/parent:bg-off-white transition-all shadow dark:shadow-dark hover:shadow-elevated dark:hover:shadow-dark-elevated w-full">
                      <div className="flex h-full items-center justify-between">
                        <span className="flex">Request camper</span>
                        <div className="inline-block align-top min-w-max child:h-6 child:w-6 dark:cssvar-secondary-to-off-white ml-2 cssvar-secondary-to-white dark:group-hover/button:cssvar-secondary-to-off-black dark:group-hover/parent:cssvar-secondary-to-off-black">
                          <svg width="32" height="32" viewBox="0 0 32 32">
                            <g fill="none" fillRule="evenodd">
                              <path
                                d="m22.126 16-7.647-7.647a1.207 1.207 0 0 0-1.705 0l-.42.42a1.204 1.204 0 0 0 0 1.705L17.876 16l-5.522 5.522a1.203 1.203 0 0 0 0 1.704l.42.422c.47.47 1.235.469 1.705-.002L22.126 16z"
                                fill="var(--svg-color-secondary, #fff)"
                              ></path>
                            </g>
                          </svg>
                        </div>
                      </div>
                    </Link>
                     
                     
                     
                    </div>

                   
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
       
      </main>
      <Footer />
    </>
  );
}
export default Availabilityinfo;
